import { render, screen } from '@testing-library/react'
import UbTrainingPage from './UbTrainingPage'

describe('UbTrainingPage', () => {
  test('renders the course history, images and official information link', () => {
    render(<UbTrainingPage />)

    expect(screen.getByRole('heading', { name: 'Curso Superior Universitario en Educación Menstrual' })).toBeTruthy()
    expect(screen.getByRole('heading', { name: 'Origen' })).toBeTruthy()
    expect(screen.getByRole('heading', { name: 'Trayectoria' })).toBeTruthy()
    expect(screen.getByRole('heading', { name: 'El convenio' })).toBeTruthy()
    expect(screen.getAllByRole('img')).toHaveLength(4)
    expect(screen.getAllByText('Formación on-line · 125 horas · 5 créditos ECTS')).toHaveLength(2)

    const informationLink = screen.getByRole('link', { name: 'Más información' })
    expect(informationLink.getAttribute('href')).toContain('web.ub.edu')
    expect(informationLink.getAttribute('target')).toBe('_blank')
  })
})
